import * as React from "react";
import { SandpackThemeContext } from "../contexts/themeContext";
export var useSandpackTheme = function useSandpackTheme() {
  var _React$useContext = React.useContext(SandpackThemeContext),
      theme = _React$useContext.theme,
      id = _React$useContext.id;

  return {
    theme: theme,
    themeId: id
  };
};